import PropTypes from 'prop-types'

function WeekNumber ({ weekNumber }) {
  return (
    <div
      className='react-datepicker__week-number'
      aria-label={`week-${weekNumber}`}
    >
      {weekNumber}
    </div>
  )
}

WeekNumber.displayName = 'WeekNumber'

WeekNumber.propTypes = {
  weekNumber: PropTypes.number.isRequired
}

export default WeekNumber
